export default "__VITE_ASSET__8e862497__"